const mixin = {
    methods: {
        upgradeMdlDom: function(){
            $('.mdl-textfield, .mdl-checkbox').removeClass('is-upgraded').removeAttr('data-upgraded')
            componentHandler.upgradeDom()
        }
    },
    updated(){
        this.upgradeMdlDom()
    },
    mounted(){
        this.upgradeMdlDom()
    }
}
export default mixin


// WEBPACK FOOTER //
// ./reports/assets/src/mixins/mdlFix.js